const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export const ADVISORY_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const ADVISORY_IMAGE_ACCEPT = 'image/jpeg,image/png';

const ALLOWED_MIME = new Set(['image/jpeg', 'image/png']);

/**
 * Client-side checks for advisory portraits (R2 path allows jpeg/png/pdf; portraits are jpeg/png only).
 * @returns {string|null} error message or null if OK
 */
export function validateAdvisoryImageFile(file) {
  if (!file || !(file instanceof File)) return 'Choose a profile image.';
  if (!ALLOWED_MIME.has(file.type)) {
    return 'Use JPEG or PNG only.';
  }
  if (file.size > ADVISORY_IMAGE_MAX_BYTES) {
    return 'Image must be 5 MB or smaller.';
  }
  return null;
}

/**
 * POST multipart to R2-backed media upload (no admin JWT required today).
 * @param {File} file
 * @returns {Promise<string>} trimmed public URL
 */
export async function uploadMediaToR2(file) {
  const clientErr = validateAdvisoryImageFile(file);
  if (clientErr) {
    throw new Error(clientErr);
  }

  const body = new FormData();
  body.append('media', file, file.name);

  const res = await fetch(`${API_BASE_URL}/api/v1/upload/media`, {
    method: 'POST',
    body,
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg =
      typeof json.error === 'string'
        ? json.error
        : json.error?.message || json.message || 'Upload failed.';
    throw new Error(msg);
  }

  if (!json.success || typeof json.url !== 'string' || !json.url.trim()) {
    throw new Error('Invalid upload response from server.');
  }

  return json.url.trim();
}
